<template>
<div class="photo-modal">
    <v-card flat class="pa-3">
        <v-row>
            <v-col cols="12" md="6">
                <v-img :src="item.url" content></v-img>
            </v-col>
            <v-col cols="12" md="6" class="px-2">
                <v-row no-gutters>
                    <v-col cols="6">
                        <div class="important">ID</div>
                        <div class="regular text-capitalize">{{ item.id }}</div>
                    </v-col>
                    <v-col cols="6">
                        <div class="important">Status</div>
                        <div :class="item.status">{{ item.status }}</div>
                    </v-col>
                </v-row>
                <div class="important">Title</div>
                <div class="regular">{{ item.title }}</div>
                <div class="important">Place</div>
                <div class="regular">{{ item.place.name }}</div>
                <div class="important">Section</div>
                <div class="regular">{{ item.section.name }}</div>
                <div class="important">Description</div>
                <div class="regular">{{ item.description }}</div>
                <div class="my-1 d-flex">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">forum</v-icon>
                        </template>
                        <span>Comments</span>
                    </v-tooltip>
                    <span class="px-1">{{ item.comment_sum }}</span>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">star_border</v-icon>
                        </template>
                        <span>Rating</span>
                    </v-tooltip>
                    <span class="px-1">{{ item.rating_avg }}</span>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">priority_high</v-icon>
                        </template>
                        <span>Order</span>
                    </v-tooltip>
                    <span class="px-1">{{ item.order }}</span>
                </div>
            </v-col>
        </v-row>
    </v-card>
</div>
</template>
<script>
import defaults from "../utils/PropDefaults.js";
export default {
    props: {
        item: {
            type: Object,
            default: defaults.photo_item
        },
    },
    methods: {
        emitClick() {
            this.$emit('click');
        },
    },

}
</script>
